export default class ApiConfiguration {
  // Mapbox configuration
  public static readonly getMapboxToken = () =>
    window.VITE_MAPBOX_TOKEN || import.meta.env.VITE_MAPBOX_TOKEN;
  public static readonly MAPBOX_DATA_OF_SINGLE_LOCATION: string = import.meta
    .env.VITE_MAPBOX_DATA_OF_SINGLE_LOCATION;
  // Humotion Api configuration
  public static readonly getApiUrl = () =>
    window.VITE_API || import.meta.env.VITE_API;
  public static readonly GET_SPORTS_LOCATIONS_URL: string = import.meta.env
    .VITE_TRACK_API_GET_SPORTS_LOCATIONS;
  public static readonly GET_SPORTS_LOCATION_DETAILS_URL: string = import.meta
    .env.VITE_TRACK_API_GET_SPORTS_LOCATION_DETAIL;
  public static readonly GET_SPORTS_LOCATION_SVG_URL: string = import.meta.env
    .VITE_TRACK_API_GET_SPORTS_LOCATION_SVG;
  public static readonly GET_SPORTS_LOCATION_SVG_GEORECTANGLE_URL: string =
    import.meta.env.VITE_TRACK_API_GET_SPORTS_LOCATION_SVG_GEORECTANGLE;
}
